/**
 * Joyee Banner Carousel
 * Crossfade slideshow with autoplay, dot navigation, touch swipe, and progress ring.
 */
(function() {
  document.querySelectorAll('[data-joyee-carousel]').forEach(function(section) {
    var track  = section.querySelector('[data-joyee-carousel-track]');
    var slides = [].slice.call(section.querySelectorAll('[data-joyee-carousel-slide]'));
    var dots   = [].slice.call(section.querySelectorAll('[data-joyee-carousel-dot]'));
    if (!track || slides.length <= 1) return;

    var autoplaySpeed      = (parseInt(section.dataset.autoplaySpeed, 10) || 5) * 1000;
    var transitionDuration = parseInt(section.dataset.transition, 10) || 600;
    // Auto-rotate is on unless the setting explicitly turned it off. When off,
    // the slideshow only advances via dots or swipe.
    var autoplayEnabled    = section.dataset.autoplay !== 'false';
    var totalSlides        = slides.length;
    var currentIndex       = 0;
    var timer              = null;
    var isTransitioning    = false;
    var reducedMotion      = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    section.style.setProperty('--jc-autoplay-duration', autoplaySpeed + 'ms');
    section.setAttribute('data-jc-autoplay', (reducedMotion || !autoplayEnabled) ? 'false' : 'true');
    section.setAttribute('data-jc-paused', 'false');

    var pausedByHover = false;
    var pausedByFocus = false;

    /*
      Slide videos ship inside <template> so they are not fetched at page load
      (see the note in joyee-banner-carousel.liquid). Hydrate one when it is
      about to be seen, and only for the breakpoint currently on screen - the
      other one is display:none and would be pure waste.

      Slide 0 is already hydrated by the inline script in the section; the
      template is gone by then, so this call is a no-op for it.
    */
    var mobileQuery = window.matchMedia('(max-width: 767px)');

    function hydrate(idx) {
      var slide = slides[idx];
      if (!slide) return;
      var box = slide.querySelector(mobileQuery.matches ? '.joyee-carousel__media--mobile' : '.joyee-carousel__media--desktop');
      if (!box) box = slide.querySelector('.joyee-carousel__media--desktop, .joyee-carousel__media--mobile');
      if (!box) return;
      var tpl = box.querySelector('template[data-jc-video]');
      if (!tpl) return;
      box.insertBefore(tpl.content.cloneNode(true), tpl);
      tpl.remove();
      var video = box.querySelector('video');
      if (!video) return;
      // Same reason as the inline script in the section: a <video> parsed inside
      // a <template> never ran resource selection, so start it explicitly rather
      // than trusting the autoplay attribute to fire on a cloned element.
      if (video.load) video.load();
      // Autoplay can still be refused (data saver, low power mode). Nothing to
      // do about it, but do not let the rejection surface as an unhandled error.
      if (video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
    }

    /*
      Off-screen slides sit at opacity 0, not display:none, so their videos keep
      decoding frames the visitor cannot see - real CPU on a phone that is
      already fighting the app scripts. Only the visible slide plays.
    */
    function syncPlayback() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === currentIndex) {
          if (video.paused && video.play) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    function restartRing() {
      var dot = dots[currentIndex];
      if (!dot) return;
      var c = dot.querySelector('.joyee-carousel__dot-ring circle');
      if (!c) return;
      c.style.animation = 'none';
      void c.offsetWidth;
      c.style.animation = '';
    }

    function goTo(idx) {
      if (idx === currentIndex || isTransitioning) return;
      isTransitioning = true;
      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');
      currentIndex = ((idx % totalSlides) + totalSlides) % totalSlides;
      hydrate(currentIndex);
      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
      restartRing();
      syncPlayback();
      // One slide of runway, so a swipe lands on a video that is already
      // buffering rather than a blank box.
      hydrate((currentIndex + 1) % totalSlides);
      setTimeout(function() { isTransitioning = false; }, transitionDuration);
    }

    function next() { goTo(currentIndex + 1); }
    function setPaused() { section.setAttribute('data-jc-paused', (pausedByHover || pausedByFocus) ? 'true' : 'false'); }
    function start() { if (!autoplayEnabled || reducedMotion || pausedByHover || pausedByFocus) return; stop(); timer = setInterval(next, autoplaySpeed); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.index, 10)); start(); });
    });

    var sx = 0, sy = 0;
    track.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', function(e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) { dx < 0 ? next() : goTo(currentIndex - 1); start(); }
    }, { passive: true });

    section.addEventListener('mouseenter', function() { pausedByHover = true;  setPaused(); stop(); });
    section.addEventListener('mouseleave', function() { pausedByHover = false; setPaused(); start(); });
    section.addEventListener('focusin',    function() { pausedByFocus = true;  setPaused(); stop(); });
    section.addEventListener('focusout',   function() { pausedByFocus = false; setPaused(); start(); });

    // Slide 1 gets hydrated up front for the same reason: the first swipe or the
    // first autoplay tick should not be the moment the download starts.
    if (totalSlides > 1) hydrate(1);

    // hydrate() starts whatever it inserts, so the pre-warmed slide 1 would sit
    // there playing behind slide 0. Settle playback to match what is on screen.
    syncPlayback();

    // A breakpoint change (rotation, desktop resize) swaps which container is
    // visible, so the newly visible one may still be holding its template.
    var onBreakpointChange = function () { hydrate(currentIndex); syncPlayback(); };
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onBreakpointChange);
    else if (mobileQuery.addListener) mobileQuery.addListener(onBreakpointChange);

    start();
  });
})();